// jQuery は WordPress 同梱のものを使う（build.mjs の banner で $ / jQuery を供給）。
// 旧 webpack の `import './autoload/**/*'`（import-glob）は autoload/ が存在しないため削除した。

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import single from './routes/single';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  home,
  aboutUs,
  pageTemplateReport: single,
  single
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
